<!--
  DEPRECATED: This component is no longer in use as of December 2025.
  The sidebar navigation has been removed in favor of direct navigation through the profile page.
  This file is kept for reference only and may be removed in future versions.
-->

<div id="sidebar" style="display: none;">
  <div class="sidebar-content">
    <button (click)="closeSidebar()" class="close-button">
      <img src="assets/icon/close-x-svgrepo-com.svg" alt="Close Icon">
    </button>
    <img [src]="companyLogoUrl" [alt]="logoState.managementCompany ? logoState.managementCompany + ' Logo' : 'Company Logo'" class="company-logo" />
    <ul class="sidebar-menu">
      <li (click)="navigateTo('schedule')">Horarios</li>
      <li (click)="navigateTo('route')">Recorrido</li>
      <li (click)="navigateTo('profile')">Mis datos</li>
      <li (click)="navigateTo('contact')">Contacto</li>
      <li (click)="navigateTo('social-media')">Redes Sociales</li>
    </ul>
    <div class="logout-container">
      <button class="logout-button" (click)="logout()">
        <i class="fas fa-sign-out-alt"></i>
        <span>Cerrar Sesión</span>
      </button>
    </div>
  </div>
</div>
